import GjwTable from './gjwTable/index'
import GjwPagination from './gjwPagination/index'
import GjwSearch from './gjwSearch/index'
import GjwSelect from './gjwSelect/index'
import GjwDialog from './gjwDialog/index'
import GjwCheckboxGroup from './gjwCheckboxGroup/index'
import GjwForm from './gjwForm/index'
import GjwSearchForm from './gjwSearchForm/index'
import GjwImportFile from './gjwImportFile/index'
import GjwListPageLayout from './gjwListPageLayout/index'
import GjwListPage from './gjwListPage/index'
import GjwStatusCell from './gjwStatusCell/index'

// 存储组件列表
const components = [
  GjwTable,
  GjwPagination,
  GjwSearch,
  GjwSelect,
  GjwDialog,
  GjwCheckboxGroup,
  GjwForm,
  GjwSearchForm,
  GjwImportFile,
  GjwListPageLayout,
  GjwListPage,
  GjwStatusCell,
]

// 定义 install 方法，接收 Vue 作为参数。如果使用 use 注册插件，则所有的组件都将被注册
const install = function(Vue) {
  // 判断是否安装
  if (install.installed) { return }
  // 遍历注册全局组件
  components.map((component) => Vue.component(component.name, component))
}

// // 判断是否是直接引入文件
// if (typeof window !== 'undefined' && window.Vue) {
//   install(window.Vue)
// }

export default {
  // 导出的对象必须具有 install，才能被 Vue.use() 方法安装
  install,
  GjwTable,
  GjwPagination,
  GjwSearch,
  GjwSelect,
  GjwDialog,
  GjwCheckboxGroup,
  GjwForm,
  GjwSearchForm,
  GjwImportFile,
  GjwListPageLayout,
  GjwListPage,
  GjwStatusCell,
}
